import type { HTMLAttributes } from 'react';
import { Button, Caption } from '@telegram-apps/telegram-ui';
import { formatImageUrl } from '../../lib/imageUrl';
import { PRODUCT_IMAGE_OBJECT_FIT } from '../../lib/imagePolicy';
import type { ProductMediaItem } from '../../types/product';

type ProductMediaViewerOverlayProps = {
  media: ProductMediaItem[];
  viewerMedia: ProductMediaItem;
  swipeHandlers: HTMLAttributes<HTMLDivElement>;
  onClose: () => void;
};

export function ProductMediaViewerOverlay({
  media,
  viewerMedia,
  swipeHandlers,
  onClose,
}: ProductMediaViewerOverlayProps) {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1000,
        background: 'rgba(0,0,0,0.92)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
      }}
      onClick={onClose}
    >
      <div
        {...swipeHandlers}
        onClick={(event) => event.stopPropagation()}
        style={{ touchAction: media.length > 1 ? 'pan-y' : 'auto' }}
      >
        <img
          src={formatImageUrl(viewerMedia.url)}
          alt={viewerMedia.title}
          style={{
            maxWidth: '100%',
            maxHeight: '82vh',
            objectFit: PRODUCT_IMAGE_OBJECT_FIT,
            borderRadius: 8,
          }}
        />
      </div>
      <div style={{ width: '100%', maxWidth: 420, marginTop: 12 }}>
        <Caption style={{ color: '#fff', display: 'block', textAlign: 'center', marginBottom: 8 }}>
          {viewerMedia.title}
        </Caption>
        <Button mode="filled" stretched size="m" onClick={onClose}>
          Закрыть
        </Button>
      </div>
    </div>
  );
}
